import React from 'react';
import { Link } from 'react-router-dom';

const CittadinoPage = () => (
  <main data-testid="cittadino-page" className="pt-24 min-h-screen">
    <section className="py-16">
      <div className="max-w-5xl mx-auto px-6">
        <p className="font-mono text-xs text-[#00FF41] uppercase tracking-wider mb-4 text-center">Per ogni cittadino</p>
        <h1 className="text-4xl md:text-5xl font-black text-white text-center mb-4">
          Cosa fa l'AI_COVO <span className="text-[#00FF41]">per te?</span>
        </h1>
        <p className="text-zinc-400 text-center max-w-2xl mx-auto mb-16">
          Esempi concreti di come il nostro Hub cambia la vita quotidiana delle persone della Valdelsa.
        </p>

        {/* Esempio 1: Nonna Maria e lo SPID */}
        <div className="bg-[#0A0A0A] border-l-4 border-[#00FF41] p-8 mb-8" data-testid="esempio-spid">
          <div className="flex items-start gap-6">
            <div className="hidden md:block text-6xl">👵</div>
            <div className="flex-1">
              <p className="text-[#00FF41] font-mono text-xs uppercase tracking-wider mb-2">Anziani 70+ — Formazione Digitale</p>
              <h2 className="text-2xl font-bold text-white mb-4">Maria, 78 anni, pensionata di Colle</h2>
              
              <div className="bg-black/40 border border-red-500/30 p-4 mb-4">
                <p className="text-red-400 font-bold text-sm mb-1">IL PROBLEMA</p>
                <p className="text-zinc-400 text-sm">Maria non riesce ad attivare lo <strong className="text-white">SPID</strong>. Non sa cos'è. Il figlio vive a Milano, il CAF ha 3 settimane di attesa. Per prenotare una visita medica online, è costretta a chiedere al vicino — che non sempre c'è.</p>
              </div>

              <div className="bg-black/40 border border-[#00FF41]/30 p-4 mb-4">
                <p className="text-[#00FF41] font-bold text-sm mb-1">LA SOLUZIONE — AI_COVO</p>
                <p className="text-zinc-300 text-sm">Maria viene nell'AI_COVO il martedì mattina. Un volontario la guida passo passo:</p>
                <ol className="list-decimal pl-6 mt-2 space-y-2 text-zinc-400 text-sm">
                  <li><strong className="text-white">Attivazione SPID</strong> — scelta del provider (PosteID), riconoscimento in sede, configurazione password sicura</li>
                  <li><strong className="text-white">Accesso CIE</strong> — come usare la Carta d'Identità Elettronica con lo smartphone</li>
                  <li><strong className="text-white">Fascicolo Sanitario</strong> — prenotazione visite, ritiro referti online</li>
                  <li><strong className="text-white">Home banking</strong> — controllo conto, pagamento bollette, bonifici</li>
                </ol>
              </div>

              <div className="bg-[#00FF41]/10 border border-[#00FF41]/30 p-4">
                <p className="text-white font-bold text-sm mb-1">RISULTATO</p>
                <p className="text-zinc-300 text-sm">In 2 ore, Maria ha il suo SPID attivo, sa prenotare le visite dal telefono e paga le bollette da sola. <strong className="text-[#00FF41]">Non dipende più da nessuno.</strong></p>
              </div>
            </div>
          </div>
        </div>

        {/* Esempio 2: Andrea e il Google Account */}
        <div className="bg-[#0A0A0A] border-l-4 border-blue-500 p-8 mb-8" data-testid="esempio-google">
          <div className="flex items-start gap-6">
            <div className="hidden md:block text-6xl">👨‍💻</div>
            <div className="flex-1">
              <p className="text-blue-400 font-mono text-xs uppercase tracking-wider mb-2">Gen X 45-59 — Competenze Digitali</p>
              <h2 className="text-2xl font-bold text-white mb-4">Andrea, 52 anni, artigiano di Poggibonsi</h2>
              
              <div className="bg-black/40 border border-red-500/30 p-4 mb-4">
                <p className="text-red-400 font-bold text-sm mb-1">IL PROBLEMA</p>
                <p className="text-zinc-400 text-sm">Andrea ha una piccola falegnameria. Usa il telefono per chiamare e WhatsApp, ma non ha un <strong className="text-white">Google Account</strong>. Non sa usare Google Drive, non può accedere a YouTube per pubblicare i video dei suoi lavori, non sa creare un profilo Google Business per farsi trovare dai clienti.</p>
              </div>

              <div className="bg-black/40 border border-blue-500/30 p-4 mb-4">
                <p className="text-blue-400 font-bold text-sm mb-1">LA SOLUZIONE — AI_COVO</p>
                <p className="text-zinc-300 text-sm">Andrea viene nell'AI_COVO il giovedì sera dopo il lavoro. In un percorso di 3 incontri:</p>
                <ol className="list-decimal pl-6 mt-2 space-y-2 text-zinc-400 text-sm">
                  <li><strong className="text-white">Creazione Google Account</strong> — email @gmail.com, password sicura, autenticazione a due fattori</li>
                  <li><strong className="text-white">Google Business Profile</strong> — la falegnameria appare su Google Maps con foto, orari, recensioni</li>
                  <li><strong className="text-white">Google Drive + YouTube</strong> — archivia preventivi nel cloud, pubblica video dei lavori finiti</li>
                  <li><strong className="text-white">Google Calendar</strong> — gestisce appuntamenti e scadenze dal telefono</li>
                </ol>
              </div>

              <div className="bg-blue-500/10 border border-blue-500/30 p-4">
                <p className="text-white font-bold text-sm mb-1">RISULTATO</p>
                <p className="text-zinc-300 text-sm">In 3 settimane, la falegnameria di Andrea ha un profilo Google con 4,8 stelle, riceve prenotazioni online e ha triplicato le richieste di preventivo. <strong className="text-blue-400">Il digitale diventa un alleato, non un ostacolo.</strong></p>
              </div>
            </div>
          </div>
        </div>

        {/* Esempio 3: Doposcuola ragazzi */}
        <div className="bg-[#0A0A0A] border-l-4 border-orange-500 p-8 mb-8" data-testid="esempio-doposcuola">
          <div className="flex items-start gap-6">
            <div className="hidden md:block text-6xl">🧒</div>
            <div className="flex-1">
              <p className="text-orange-400 font-mono text-xs uppercase tracking-wider mb-2">Under 16 — Doposcuola</p>
              <h2 className="text-2xl font-bold text-white mb-4">Sofia, 12 anni, studentessa di Colle</h2>
              
              <div className="bg-black/40 border border-red-500/30 p-4 mb-4">
                <p className="text-red-400 font-bold text-sm mb-1">IL PROBLEMA</p>
                <p className="text-zinc-400 text-sm">I genitori di Sofia lavorano fino alle 18. Dopo la scuola, Sofia è sola a casa con il tablet. Non fa i compiti, guarda TikTok per 4 ore al giorno.</p>
              </div>

              <div className="bg-black/40 border border-orange-500/30 p-4 mb-4">
                <p className="text-orange-400 font-bold text-sm mb-1">LA SOLUZIONE — AI_COVO</p>
                <p className="text-zinc-300 text-sm">Sofia viene nell'AI_COVO ogni pomeriggio dalle 14 alle 18. Compiti assistiti, laboratori creativi, coding per ragazzi. Uno spazio sicuro dove crescere.</p>
              </div>

              <div className="bg-orange-500/10 border border-orange-500/30 p-4">
                <p className="text-white font-bold text-sm mb-1">RISULTATO</p>
                <p className="text-zinc-300 text-sm">I voti di Sofia migliorano, usa il tablet per programmare invece che per scrollare. <strong className="text-orange-400">I genitori lavorano tranquilli.</strong></p>
              </div>
            </div>
          </div>
        </div>

        {/* CTA finale */}
        <div className="text-center mt-16">
          <p className="text-zinc-400 mb-4">Vuoi saperne di più o iscriverti come volontario?</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="mailto:riccardorossi1984@gmail.com?subject=Info%20Progetto%20AI_COVO" className="btn-primary bg-[#00FF41] text-black border-[#00FF41] hover:bg-[#33FF66]" data-testid="cittadino-contattaci">
              Contattaci
            </a>
            <Link to="/dona" className="btn-primary" data-testid="cittadino-dona">
              Sostieni il progetto
            </Link>
          </div>
        </div>
      </div>
    </section>
  </main>
);

export default CittadinoPage;
